module.exports = __webpack_public_path__ + "static/eshop4-b15220c407f5ab9d6dd2b0fa7f60df09.gif";